module.exports = "/_next/static/images/menu-category-list-cooking-327848c5501698da7fcd81cb04f64e71.jpg";